import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { loadingBarReducer, loadingBarMiddleware } from 'react-redux-loading-bar'
import { loadState, saveState, saveAdminState } from './localStorage';

import { user, admin } from './reducers/user-reducer';
import { website } from './reducers/website-reducer';
import { images, imagesPreview, links, about, activities, customization } from './reducers/create-reducer';

const logger = createLogger();

const rootReducers = combineReducers({ website, user, admin, images, imagesPreview, about, links, customization, activities, loadingBar: loadingBarReducer });

const persistedState = loadState();

export const store = createStore(rootReducers, persistedState, applyMiddleware(thunkMiddleware, logger, loadingBarMiddleware({
      promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAILURE'],
    })));


store.subscribe((state, admin) => {
  saveState({
  	links: store.getState().links,
  	about: store.getState().about,
  	user: store.getState().user,
  	website: store.getState().website,
  	activities: store.getState().activities,
  	customization: store.getState().customization,
    images: store.getState().images,
    admin: store.getState().admin
    });
});